import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { SpinnerVisibilityService } from 'ng-http-loader';
import Swal from 'sweetalert2'
import { BMApiService } from '../../../services/bm.service';
import { Router } from '@angular/router';
import { UserService } from '../../../services/user.service';
import {
  AngularGridInstance,
  Column,
  FieldType,
  Filters,
  Formatter,
  GridOption,
  FileType,
  Formatters,
  GridStateChange,
  MenuCallbackArgs,
  parseBoolean
} from 'angular-slickgrid';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { UtilityService } from '../../../services/utility.service';
import { AdminApiService } from '../../../services/admin.service';
import { tranbenchmarkkpi, tranbenchmarkkpihistory, benchmarkkpirelease, annualPerformanceBM, annualPracticeBM, annualStatusHistroy } from '../../../models/slakpi';
import { division, department, geographicArea, projectImportance } from '../../../models/admin';
import { ToasterService } from '../../../toaster.service';
import { uniqBy } from 'lodash';
@Component({
  selector: 'annual-practice-bm',
  templateUrl: './annual-practice-bm.component.html',
  styleUrls: ['./annual-practice-bm.component.css']
})
export class AnnualPracticeBMComponent implements OnInit {
  
  
  public gridApi: any;
  public gridColumnApi: any;
  public columnDefs: any;
  public defaultColDef: any;
  public rowData: any;
  public PopoverModule;
  modalRef: BsModalRef;
  submitted: boolean = false;
  @ViewChild('addtemplate', { static: false }) addtemplate: TemplateRef<any>;

  @ViewChild('statusUpdateTemplate', { static: false }) statusUpdateTemplate: TemplateRef<any>;
  @ViewChild('statusUpdateHistroyTemplate', { static: false }) statusUpdateHistroyTemplate: TemplateRef<any>;
  columnDefinitions: Column[];
  gridOptions: GridOption;
  dataset: any;
  angularGrid: AngularGridInstance;
  public loading: boolean = true;
  public pageAction: string = 'add';
  public isStart:boolean=true;
  public selectedRows: any = [];
  public division_data: any;
  public department_data: any;
  public KPIMeasure_data: any;
  public projectImportance_data: any;
  objAnnualPractice:any =new annualPracticeBM();
    searchText: string;
    data: any;
    histroyColumnDefinitions: any;
    dataHistroy: any;
    practiceStatusHistroyDataSet: any[];
    editID: any;
    login_UserID: any;
  userList: any;
  objStatusHistroy: any = new annualStatusHistroy();
  statusDDList = [{ value: 0, text: 'Draft' },{ value: 1, text: 'Accepted' }, { value: 2, text: 'Rejected' }]

  user: any = {};
  isAdmin: boolean;
  public isBMChampion: boolean = false;
  public isBMTeam: boolean = false;
  public isBMVisitor: boolean = false;
  public isBMAdmin: boolean = false;
  noDataImg: any;
  tenantUno: any;
  selectedAreaItems: any = [];
  geographicAreaList: any = [];
  targetPeerIndustry_data: { value: number; text: string; }[];
  editSelectedAreaItems: any = [];
  constructor(public restApi: BMApiService, public restAdminApi: AdminApiService, private toaster: ToasterService, public utilityService: UtilityService, private router: Router, private spinner: SpinnerVisibilityService, private userService: UserService, private modalService: BsModalService) {
    this.user = this.userService.getUserInfo();
    this.login_UserID = this.user.id;
    this.noDataImg = this.utilityService.getnodataImage();
    this.tenantUno = this.user.tenantUno;
    this.ValidateUserAccess();
  }
  //Method used To Validate User Permission

  ValidateUserAccess() {
    

    this.isAdmin = (this.user.role == 'Administrator' || this.user.role == 'BM Administrator') ? true : false;

    if (this.user.role == 'BM Champions')
      this.isBMChampion = true;
    if (this.user.role == 'BM Team')
      this.isBMTeam = true;
    if (this.user.role == 'BM Visitor')
      this.isBMVisitor = true;
    if (this.user.role == 'BM Administrator') { this.isBMAdmin = true; }

    if (!this.isAdmin) {
      let userPermissionData = this.userService.getUserRights("Annual Practice BM");
      if (userPermissionData != null && userPermissionData != undefined && userPermissionData.length > 0) {
        if (userPermissionData[0].showPage == 1) {

        }
        else {
          this.router.navigateByUrl('/access-denied');
        }
      }
    }

  }
  ngOnInit() {
    this.userService.CheckLogin();
    this.gridOptions = {
      autoHeight: true,
      enableAutoResize: true,
      enablePagination: true,
      pagination: {
        pageSizes: [5, 10, 20, 50, 100, 500],
        pageSize: 20
      },
      enableFiltering: true,
      alwaysShowVerticalScroll: false,
      enableRowSelection: true,
      autoResize: {
        containerId: 'musherat-grid',
        delay: 0,
        sidePadding: 10,
        bottomPadding: 10
      },
      enableExcelExport: true,
      enableExcelCopyBuffer: true,
      enableFilterTrimWhiteSpace: true,
      showCustomFooter: true, // display some metrics in the bottom custom footer
      enableContextMenu: true,
      enableCellMenu: true,
      forceFitColumns: true,
     
      multiSelect: false,
      rowSelectionOptions: {
        // True (Single Selection), False (Multiple Selections)
        selectActiveRow: true,
      },



    };

    this.userList = this.userService.getUserInfo();
    this.login_UserID = this.userList.id;

    this.searchText = '';
    this.getDivisions();
    this.getDepartments();
    this.getKPIMeasure();
    this.getProjectImportance();
    this.geTargetPeerIndustry();
    this.LoadPracticeBM();
    this.getGeographicArea();
  }

  angularGridReady(angularGrid: AngularGridInstance) {
    this.angularGrid = angularGrid;
    this.userService.angularGrid = angularGrid;
  }
  handleSelectedRowsChanged1(e, args) {
    
    if (Array.isArray(args.rows) && this.angularGrid) {
      this.selectedRows = this.angularGrid.gridService.getSelectedRowsDataItem();
    }
  }
  

  getDivisions() {

    let inpValue = new division();
    inpValue.userUno = this.login_UserID;
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 5;
    inpValue.tenantUno = this.tenantUno;
    this.restApi.getDivisions(inpValue)
      .subscribe(data => {
        
        this.division_data = data;
      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });
  }
  getDepartments() {

    let inpValue = new department();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.tenantUno = 1;
    inpValue.userUno = this.login_UserID;
    this.restApi.getDepartments(inpValue)
      .subscribe(data => {
        
        this.department_data = data;
      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });
  }
  getKPIMeasure() {
    this.KPIMeasure_data = [
      { value: 1, text: 'Yes' },
      { value: 0, text: 'No' }
    ];
  }
 
 

  geTargetPeerIndustry() {
    this.targetPeerIndustry_data = [
      { value: 1, text: 'Utility' },
      { value: 2, text: 'Cross industry' },
      { value: 3, text: 'Others' }
    ];
  }
  
  LoadPracticeBM() {
    
    
   
    let inpValue = new annualPracticeBM();
    inpValue.condition = 1;
    inpValue.userUno = this.login_UserID;
    inpValue.tenantUno = this.tenantUno;
    inpValue.annualPracticeBMUno = 0;   
    this.restApi.getAnnualPracticeBM(inpValue)
      .subscribe((data: any) => {
        
        this.searchText = '';
        if (data != null && data.length > 0) {

          let rtn_data=data;
          const mockDataset:any = [];
          for (let i = 0; i < rtn_data.length; i++) {
            mockDataset[i] = {
              id: rtn_data[i].annualPracticeBMUno,
              divisionUno: rtn_data[i].divisionUno,
              divisionText: rtn_data[i].divisionText,
              departmentUno: rtn_data[i].departmentUno,
              departmentText: rtn_data[i].departmentText,
              topic: rtn_data[i].topic,
              kpiMeasure: rtn_data[i].kpiMeasure,
              strategicObjectives: rtn_data[i].strategicObjectives,
              reason: rtn_data[i].reason,
              justification: rtn_data[i].justification,
              fourG: rtn_data[i].fourG,
              acceptedorNot: rtn_data[i].acceptedorNot,
              expectedOutComes: rtn_data[i].expectedOutComes,
              projectImportance: parseInt(rtn_data[i].projectImportance),
              status: rtn_data[i].status,
              comment: rtn_data[i].comment,
              targetPeerIndustry: rtn_data[i].targetPeerIndustry,
              description: rtn_data[i].description,
              areaImprovement: rtn_data[i].areaImprovement,
              specificationsRequirements:parseBoolean(rtn_data[i].specificationsRequirements),
              areaUno: rtn_data[i].areaUno,
              numberOfStrategic: parseInt(rtn_data[i].numberOfStrategic)

            };
          }
          this.dataset = uniqBy(mockDataset, 'id');
          this.data = uniqBy(mockDataset, 'id');
         // this.dataset = mockDataset;
          if (mockDataset.length > 0) {
            this.setColnDefn();
          }
          
          this.isStart = false;
          this.loading = false;
          this.spinner.hide()
        }
        else {
         this.dataset = [];
          this.isStart = false;
          this.loading = false;
          this.spinner.hide()
        }
      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });
  }

  setColnDefn() {
    let temp = this;
    this.columnDefinitions = [
      {
        id: 'divisionText', name: 'Division', field: 'divisionText', sortable: true, width:50,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'divisionText', 'divisionText'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'departmentText', name: 'Department', field: 'departmentText', sortable: true, width: 50,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'departmentText', 'departmentText'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'topic', name: 'Topic', field: 'topic', sortable: true, width: 50,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'topic', 'topic'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'strategicObjectives', name: 'Strategic Objectives', field: 'strategicObjectives', sortable: true, width: 50,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'strategicObjectives', 'strategicObjectives'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'status', name: 'Status', field: 'status', sortable: true, width: 20,
        type: FieldType.string, filterable: true,
        formatter: (row, cell, val, columnDef, data) => {
          if (data.status == 'Draft' || data.status == '')
            return '<span  class="status-area status-yellow">Draft</span>';
          else if (data.status == 'Accepted')
            return '<span  class="status-area status-green">Accepted</span>';
          else if (data.status == 'Rejected')
            return '<span  class="status-area status-red">Rejected</span>';
          
        },
        filter: {
          collection: this.uniqueArray(this.dataset, 'status', 'status'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'action', name: 'Action', field: 'action', cssClass: 'blue', width: 20,
        excludeFromExport: true,
        formatter: this.actionFormatter,
        cellMenu: {
          hideCloseButton: false,
          commandTitleKey: 'COMMANDS',
          commandItems: [
           
            {
              command: 'edit-row', titleKey: 'Edit_ROW', positionOrder: 64, title: 'Edit',
              itemVisibilityOverride: (args: MenuCallbackArgs) => {
                let data = args.dataContext;

                if (this.isBMVisitor)
                  return false;
                else return true;
              },
              iconCssClass: 'fa fa-edit', cssClass: 'green', textCssClass: 'bold',
              action: (e, args) => {
                
                this.pageAction = 'edit';
                this.selectedRows = [];
                let data = args.dataContext;
                for (let x = 0; x < this.geographicAreaList.length; x++) {
                  this.geographicAreaList[x].checked = false;
                }
                this.objAnnualPractice = data;
                this.objAnnualPractice.fourG = (this.isTrueFalseCheck(data.fourG) == true) ? "Yes" : "No";
                this.objAnnualPractice.kpiMeasure = (this.isTrueFalseCheck(data.kpiMeasure) == true) ? "Yes" : "No";
                this.objAnnualPractice.specificationsRequirements = (this.isTrueFalseCheck(data.specificationsRequirements) == true) ? "Yes" : "No";
                this.objAnnualPractice.acceptedorNot = (this.isTrueFalseCheck(data.acceptedorNot) == true) ? "Yes" : "No";
                this.selectedRows = data;
                let editAreaItems: any = [];
                editAreaItems = this.objAnnualPractice.areaUno != null && this.objAnnualPractice.areaUno != undefined && this.objAnnualPractice.areaUno != '' ? this.objAnnualPractice.areaUno.split(',') : [];

                

                if (editAreaItems.length > 0) {
                  let items = [];
                  for (var i = 0; i < editAreaItems.length; i++) {
                    items.push({
                      id: editAreaItems[i],
                      text: '',
                      checked: true
                    });
                  }
                  this.editSelectedAreaItems = items;
                }

                this.selectedAreaItems = [];
                for (let i = 0; i < this.editSelectedAreaItems.length; i++) {
                  for (let x = 0; x < this.geographicAreaList.length; x++) {
                    if (this.geographicAreaList[x].id == this.editSelectedAreaItems[i].id) {
                      this.geographicAreaList[x].checked = true;
                      this.selectedAreaItems.push(this.editSelectedAreaItems[i]);
                    }
                  }
                }
                this.modalRef = this.modalService.show(
                  this.addtemplate,
                  Object.assign({}, {
                    class: 'gray modal-lg',
                    backdrop: true,
                    keyboard: true,
                    focus: true,
                    show: false,
                    ignoreBackdropClick: true,
                    animated: true
                  })
                );
              },
              // only show command to 'Delete Row' when the task is not completed

            },
            { divider: true, command: '', positionOrder: 65 },
            {
              command: 'delete-row', titleKey: 'EDIT_ROW', positionOrder: 62, title: 'Update Status',
              itemVisibilityOverride: (args: MenuCallbackArgs) => {
                let data = args.dataContext;

                if (this.isBMVisitor)
                  return false;
                else return true;
              },
              iconCssClass: 'fa fa-refresh', cssClass: 'blue', textCssClass: 'bold',
              action: (e, args) => {
                this.pageAction = 'edit';
                

                let rdata: any = args.dataContext;
                this.editID = rdata.id;
                this.objStatusHistroy.status = (rdata.status == '') ? 'Draft' : rdata.status;
                this.objStatusHistroy.comments = '';




                this.modalRef = this.modalService.show(
                  this.statusUpdateTemplate,
                  Object.assign({}, { class: 'gray modal-medium' })
                );

              },
              // only show command to 'Delete Row' when the task is not completed

            },
            { divider: true, command: '', positionOrder: 65 },
            {
              command: 'delete-row', titleKey: 'EDIT_ROW', positionOrder: 62, title: 'Status History',
              iconCssClass: 'fa fa-lg fa-info-circle', cssClass: 'blue', textCssClass: 'bold',
              action: (e, args) => {
                this.pageAction = 'edit';
                

                let rdata: any = args.dataContext;
                this.editID = rdata.id;
                this.loadBMRequestStatusHistroy();
                this.objStatusHistroy.comments = '';
                this.modalRef = this.modalService.show(
                  this.statusUpdateHistroyTemplate,
                  Object.assign({}, { class: 'gray modal-lg' })
                );
              },
              // only show command to 'Delete Row' when the task is not completed

            },
            { divider: true, command: '', positionOrder: 65 },
            {
              command: 'delete-row', titleKey: 'DELETE_ROW', positionOrder: 66, title: 'Delete',
              itemVisibilityOverride: (args: MenuCallbackArgs) => {
                let data = args.dataContext;

                if (this.isBMVisitor)
                  return false;
                else return true;
              },
              iconCssClass: 'fa fa-trash', cssClass: 'red', textCssClass: 'bold',
              action: (e, args) => {
                Swal.fire({
                  title: 'Delete',
                  text: 'Please confirm to delete the record',
                  type: 'warning',
                  showCancelButton: true,
                  confirmButtonText: 'Ok',
                  cancelButtonText: 'Cancel'
                }).then((result) => {
                  if (result.value) {
                    this.pageAction = 'delete';
                     this.deleteAnnualPracticeBM(args.dataContext);
                  } else if (result.dismiss === Swal.DismissReason.cancel) {

                  }
                })
              }
            },
          ],
        }
      }




    ]


  }
  isTrueFalseCheck(value: any) {
    if (value == 'Yes') {
      return true;
    }
    else if (value == 'No') {
      return false;
    }
    else {
      return '';
    }
  }
    openModalWithClass() {
    this.pageAction = "add";
    this.objAnnualPractice = new annualPerformanceBM();
      for (let x = 0; x < this.geographicAreaList.length; x++) {
        this.geographicAreaList[x].checked = false;
      }
    //this.selTab = true;
    this.modalRef = this.modalService.show(
      this.addtemplate,
      Object.assign({}, {
        class: 'gray modal-lg',
        backdrop: true,
        keyboard: true,
        focus: true,
        show: false,
        ignoreBackdropClick: true,
        animated: true
      })
    );
  }

  

  actionFormatter: Formatter = (row, cell, value, columnDef, dataContext) => {
    return `<div class="fake-hyperlink"> <i class="fa fa-ellipsis-h fa-lg"></i></div>`;
  };
  uniqueArray(arrayList, val, label) {
    var temp = this;
    var aList = [];
    if (arrayList) {
      for (var i = 0, l = arrayList.length; i < l; i++)
        if (aList.filter(item => item.label == temp.Checklabel(arrayList[i][label])).length == 0) {

          aList.push({
            'value': this.CheckValue(arrayList[i][val]), 'label': this.Checklabel(arrayList[i][label])
          });
        }
    }


    aList.sort((a: any, b: any) => {
      if (a['value'] < b['value']) {
        return -1;
      } else if (a['value'] > b['value']) {
        return 1;
      } else {
        return 0;
      }
    });
    return aList;
  }

  Checklabel(val) {
    if (val != undefined && val != null && val != '' && val != ' ')
      return val;
    else
      return ''

  }

  CheckValue(val) {
    if (val != undefined && val != null && val != '' && val != ':')
      return val;
    else
      return ' '

  }

  IsNull(val) {
    if (val != undefined && val != null && val != '') {
      val = val.trim()
      return val.charAt(0).toUpperCase() + val.slice(1);
    }
    else
      return ' '

  }


  onSave(val) {
    
    if (val) {
      if (this.selectedAreaItems.length == 0) {
        this.toaster.show('error', 'Error', 'Targeted Peer Geographic Areas is Required');
        return false;
      }
      this.addEditAnnualPracticeBM(this.objAnnualPractice);
    }
    return false;
  }

  addEditAnnualPracticeBM(data1: any) {
    
    let objAnnualPBM = new annualPracticeBM();
    let finalArea = '';
    let selectedArea: any = [];
    for (let i = 0; i < this.selectedAreaItems.length; i++) {
      selectedArea.push(this.selectedAreaItems[i].id);
    }
    finalArea = (selectedArea.length > 0) ? selectedArea.toString() : '';
    
    objAnnualPBM = data1;
    objAnnualPBM.annualPracticeBMUno = (this.pageAction == 'add') ? 0 : data1.id;
    objAnnualPBM.userUno = this.login_UserID;
    objAnnualPBM.tenantUno = this.tenantUno;
    objAnnualPBM.fourG = (data1.fourG=='Yes')?true:false;
    objAnnualPBM.kpiMeasure = (data1.kpiMeasure == 'Yes') ? true : false;
    objAnnualPBM.acceptedorNot = (data1.acceptedorNot == 'Yes') ? true : false;
    objAnnualPBM.status = (data1.status != null && data1.status != undefined) ? data1.status : 'Draft';
    objAnnualPBM.condition = (this.pageAction == 'add') ? 0 : 1;
    objAnnualPBM.specificationsRequirements = (data1.specificationsRequirements == 'Yes') ? true : false;
    objAnnualPBM.areaUno = finalArea;
    this.restApi.addEditAnnualPracticeBM(objAnnualPBM)
      .subscribe(data => {
        
        if (data != null && data != undefined && data != '' && data != 'failure') {
         // Swal.fire('Error', 'Something went wrong', 'error');
          this.selectedRows = [];
          let message = (this.pageAction == 'add') ? 'Annual Practice Saved' : 'Annual Practice Updated';
          this.toaster.show('success', 'Success', message);
          this.modalRef.hide();
          setTimeout(() => { this.spinner.hide(); this.loading = true; this.LoadPracticeBM(); }, 900);
         
        }
        else {
          
          //Swal.fire({
          //  type: 'success',
          //  title: 'Bench Mark KPI Released.',
          //  showConfirmButton: false,
          //  timer: 1500
          //})
          this.toaster.show('error', 'Error', 'Something went wrong');
          this.spinner.hide();
          
          
        }



      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        //this.spinner.hide();
      });
  }

  deleteAnnualPracticeBM(data1: any) {
    
    let objAnnualPBM = new annualPracticeBM();

    
    objAnnualPBM = data1;
    objAnnualPBM.annualPracticeBMUno = data1.id;
    objAnnualPBM.userUno = this.login_UserID;
    objAnnualPBM.tenantUno = this.tenantUno;
    objAnnualPBM.fourG = (data1.fourG == 'Yes') ? true : false;
    objAnnualPBM.kpiMeasure = (data1.kpiMeasure == 'Yes') ? true : false;
    objAnnualPBM.acceptedorNot = (data1.acceptedorNot == 'Yes') ? true : false;
    
    objAnnualPBM.condition = 2;

    this.restApi.addEditAnnualPracticeBM(objAnnualPBM)
      .subscribe(data => {
        
        if (data != null && data != undefined && data != '' && data != "failure") {
          this.selectedRows = [];
          this.toaster.show('success', 'Success', 'Annual Performance deleted');
          // this.modalRef.hide();
          setTimeout(() => { this.spinner.hide(); this.loading = true; this.LoadPracticeBM(); }, 900);
        }
        else {
          // Swal.fire('Error', 'Something went wrong', 'error');
          this.toaster.show('error', 'Error', 'Something went wrong');
          this.spinner.hide();
        }



      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        //this.spinner.hide();
      });
  }

  searchGrid() {
    
    if (this.searchText != "") {
      this.dataset = this.data.filter(a =>
        a.divisionText && a.divisionText.toLowerCase().includes(this.searchText.toLowerCase())
        || (a.departmentText && a.departmentText.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.topic && a.topic.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.status && a.status.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.strategicObjectives && a.strategicObjectives.toLowerCase().includes(this.searchText.toLowerCase())));
    }
    else
      this.dataset = this.data;
  }


  onStatusSubmit(val1) {
    
    if (!val1) {
      this.toaster.show('error', 'Error', 'Please enter the required information');
      return
    }

    else {
      this.updateAnnualPerformanceStatus(this.objStatusHistroy);
    }
  }
  updateAnnualPerformanceStatus(data1: any) {
    



    let obj = new annualStatusHistroy();
    obj = data1;
    obj.id = (this.editID) ? this.editID : 0;
    obj.comments = (this.objStatusHistroy.comments) ? this.objStatusHistroy.comments : '';
    obj.status = this.objStatusHistroy.status;
    obj.userUno = this.login_UserID;
    obj.tenantUno = this.tenantUno;
    obj.flag = 'AnnualPracticeBM';
    this.restApi.updateAnnualStatus(obj)
      .subscribe(data => {

        if (data != null && data != undefined && data != '' && data != 'failure') {

          this.toaster.show('error', 'Error', 'Something went wrong');
          this.spinner.hide();


        }
        else {
          this.toaster.show('success', 'Success', 'Status Updated.');
          setTimeout(() => {
            this.objStatusHistroy = new annualStatusHistroy();
            this.spinner.hide();
            this.LoadPracticeBM();
            this.modalRef.hide();
          }, 500);
        }



      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        //this.spinner.hide();
      });
    return true;

  }
  loadBMRequestStatusHistroy() {
    this.spinner.show();
    let inpValue = new annualStatusHistroy();
    inpValue.flag = 'AnnualPracticeBM';
    inpValue.id = (this.editID) ? this.editID : 0;
    inpValue.userUno = this.login_UserID;

    this.restApi.getAnnualStatus(inpValue)
      .subscribe(data => {
        

        this.dataHistroy = uniqBy(data, 'id');
        const mockDataset = [];
        for (let i = 0; i < this.dataHistroy.length; i++) {

          mockDataset[i] = {
            id: this.dataHistroy[i].id,
            itemUno: this.dataHistroy[i].itemUno,
            comments: this.dataHistroy[i].comments,
            status: this.dataHistroy[i].status,
            enteredBy: this.dataHistroy[i].enteredBy,
            enteredOn: this.dataHistroy[i].enteredOn,
            createdBy: this.dataHistroy[i].createdBy

          };
        }
        this.practiceStatusHistroyDataSet = mockDataset;
        if (mockDataset.length > 0) {
          this.setGridPracticeStatusHistroyDefn();
        }
        else {
          this.setGridPracticeStatusHistroyDefn();
        }

        this.loading = false;
        this.spinner.hide()
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
  }
  setGridPracticeStatusHistroyDefn() {
    let temp = this;
    this.histroyColumnDefinitions = [
      {
        id: 'status', name: 'Status', field: 'status', sortable: true, type: FieldType.string, filterable: false, width: 50,
        filter: {
          collection: this.uniqueArray(this.dataset, 'status', 'status'),
          model: Filters.multipleSelect,

        }
      },
      {
        id: 'comments', name: 'Comments', field: 'comments', sortable: true, type: FieldType.string, filterable: false, width: 50,
        filter: {
          collection: this.uniqueArray(this.dataset, 'comments', 'comments'),
          model: Filters.multipleSelect,

        }
      },
      {
        id: 'createdBy', name: 'Created By', field: 'createdBy', sortable: true, type: FieldType.string, filterable: false, width: 50,
        filter: {
          collection: this.uniqueArray(this.dataset, 'enteredOn', 'enteredOn'),
          model: Filters.multipleSelect,

        }
      },

      {
        id: 'enteredBy', name: 'Modifed By', field: 'enteredBy', sortable: true, type: FieldType.string, filterable: false, width: 50,
        filter: {
          collection: this.uniqueArray(this.dataset, 'enteredBy', 'enteredBy'),
          model: Filters.multipleSelect,

        }
      },

      {
        id: 'enteredOn', name: 'Modified On', field: 'enteredOn', sortable: true, type: FieldType.string, filterable: false, width: 50,
        filter: {
          collection: this.uniqueArray(this.dataset, 'enteredOn', 'enteredOn'),
          model: Filters.multipleSelect,

        }
      },


    ]


  }
  getGeographicArea() {

    let inpValue = new geographicArea();
    inpValue.userUno = this.login_UserID;
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 5;
    inpValue.tenantUno = this.tenantUno;
    this.restApi.getGeographicArea(inpValue)
      .subscribe(data => {
        

        let rtnData: any = [];
        rtnData = data;
        let items = [];
        for (var i = 0; i < rtnData.length; i++) {
          items.push({
            id: rtnData[i].areaUno,
            text: rtnData[i].areaNameEn,
            checked: false
          });
        }
        this.geographicAreaList = items;
      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });
  }

  getProjectImportance() {

    let inpValue = new projectImportance();
    inpValue.userUno = this.login_UserID;
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 5;
    inpValue.tenantUno = this.tenantUno;
    this.restApi.getProjectImportance(inpValue)
      .subscribe(data => {
        
        this.projectImportance_data = data;
      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });
  }
  selectCheckBoxMultiple(ev: any, item: any) {
    

    if (ev.currentTarget.checked) {
      item.checked = true;
      this.selectedAreaItems.push(item);
    }
    else {
      //remove from list
      this.selectedAreaItems = this.selectedAreaItems.filter((x) => x.id != item.id);
    }
  }
  isNumberKey(evt: any, item: any = null) {
    // item.value.openPanel_year = true;
    var charCode = (evt.which) ? evt.which : evt.keyCode
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      if (charCode == 46) {
        return true
      }
      else {
        return false;
      }
    }
    return true;
  }
}


